// extracted by mini-css-extract-plugin
module.exports = {"pronunciation":"PronunciationExercises_pronunciation__3SqeO","pronunciation__wrapper":"PronunciationExercises_pronunciation__wrapper__uoJby"};